import React, { useState } from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSave } from '@fortawesome/free-solid-svg-icons';

const Notas = () => {
    const [filtros, setFiltros] = useState({
        numero_expediente: '',
        fecha_inicio: '',
        fecha_fin: '',
        nombre_conductor: '',
        cedula_conductor: '',
        numero_factura: ''
    });

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        });
    };

    const buscarReporte = async () => {
        setIsLoading(true);
        try {
            const response = await authAxios.post("facturacion/reporte_notas", filtros);
            const resultado = response.data.dato || [];
            
            const formattedData = resultado.map((item) => ({
                ...item,
                costo_conductor_editable: item.costo_conductor !== null && item.costo_conductor !== undefined ? item.costo_conductor : item.costo_tercero,
            }));
            
            setData(formattedData);
            
            if (formattedData.length === 0) {
                Swal.fire('Información', 'No se encontraron resultados con los filtros aplicados', 'info');
            }
        } catch (error) {
            console.error("Error cargando reporte:", error);
            Swal.fire("Error", "No se pudo cargar la información del reporte", "error");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCostoChange = (index, value) => {
        const newData = [...data];
        newData[index].costo_conductor_editable = value;
        setData(newData);
    };

    const actualizarCosto = async (index) => {
        const item = data[index];
        try {
            const response = await authAxios.post("facturacion/actualizar_costo_conductor", {
                id: item.id,
                costo_conductor: item.costo_conductor_editable,
            });

            if (response.data.Status || response.data.status) {
                Swal.fire("Éxito", response.data.msj || "Costo actualizado correctamente", "success");
                const newData = [...data];
                newData[index].costo_conductor = item.costo_conductor_editable;
                setData(newData);
            } else {
                Swal.fire("Error", response.data.msj || "No se pudo actualizar el costo", "error");
            }
        } catch (error) {
            console.error("Error actualizando costo:", error);
            Swal.fire("Error", "Ocurrió un problema al actualizar", "error");
        }
    };

    const calcularTotalCostoConductor = () => {
        return data.reduce((sum, item) => sum + (parseFloat(item.costo_conductor_editable) || 0), 0);
    };

    return (
        <div className="content">
            <div className="container-fluid" style={{ maxWidth: '98%' }}>
                <br />
                <div className="card">
                    <div className="card-header bg-white">
                        <h4>Reporte Global de Notas Contables</h4>
                    </div>
                    <div className="card-body">
                        {/* Filtros */}
                        <div className="row mb-3">
                            <div className="col-md-2">
                                <label>N° Factura</label>
                                <input type="text" name="numero_factura" className="form-control form-control-sm" value={filtros.numero_factura} onChange={handleInputChange} placeholder="Ej: 12345" />
                            </div>
                            <div className="col-md-2">
                                <label>Expediente / Orden</label>
                                <input type="text" name="numero_expediente" className="form-control form-control-sm" value={filtros.numero_expediente} onChange={handleInputChange} placeholder="Ej: 4510036352" />
                            </div>
                            <div className="col-md-2">
                                <label>Fecha Inicio (Servicio)</label>
                                <input type="date" name="fecha_inicio" className="form-control form-control-sm" value={filtros.fecha_inicio} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-2">
                                <label>Fecha Fin (Servicio)</label>
                                <input type="date" name="fecha_fin" className="form-control form-control-sm" value={filtros.fecha_fin} onChange={handleInputChange} />
                            </div>
                            <div className="col-md-2">
                                <label>Nombre Conductor</label>
                                <input type="text" name="nombre_conductor" className="form-control form-control-sm" value={filtros.nombre_conductor} onChange={handleInputChange} placeholder="Ej: JUAN PEREZ" />
                            </div>
                            <div className="col-md-2">
                                <label>Cédula Conductor</label>
                                <input type="text" name="cedula_conductor" className="form-control form-control-sm" value={filtros.cedula_conductor} onChange={handleInputChange} placeholder="Ej: 12345678" />
                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-12 text-end">
                                <button className="btn btn-primary" onClick={buscarReporte} disabled={isLoading}>
                                    {isLoading ? (
                                        <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Buscando...</>
                                    ) : (
                                        <><FontAwesomeIcon icon={faSearch} className="me-2" /> Buscar</>
                                    )}
                                </button>
                            </div>
                        </div>

                        {/* Tabla de Resultados */}
                        <div className="table-responsive">
                            <table className="table table-bordered table-sm table-striped table-hover">
                                <thead className="table-success">
                                    <tr>
                                        <th>Factura N°</th>
                                        <th>Cod</th>
                                        <th>Descripción</th>
                                        <th>Cant.</th>
                                        <th>Valor</th>
                                        <th>Total</th>
                                        <th>Expediente</th>
                                        <th>Placa</th>
                                        <th>Conductor</th>
                                        <th>Especificaciones</th>
                                        <th>Costo Tercero</th>
                                        <th>Costo Conductor</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan="13" className="text-center py-4">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Cargando...</span>
                                                </div>
                                                <p className="mt-2">Procesando reporte...</p>
                                            </td>
                                        </tr>
                                    ) : data && data.length > 0 ? (
                                        data.map((item, id) => (
                                            <tr key={item.id}>
                                                <td className="fw-bold">{item.numero_factura}</td>
                                                <td>{item.codigo}</td>
                                                <td style={{ fontSize: "11px" }}>{item.descripcion}</td>
                                                <td>{item.cantidad}</td>
                                                <td>{item.valor}</td>
                                                <td>{item.total}</td>
                                                <td>{item.numero_expediente}</td>
                                                <td>{item.placa}</td>
                                                <td style={{ fontSize: "11px" }}>{item.datos_conductor}<br/>{item.nombre_conductor}</td>
                                                <td style={{ fontSize: "11px" }}>{item.especificaciones}</td>
                                                <td>{item.costo_tercero}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm" style={{ width: "100px" }}
                                                        value={item.costo_conductor_editable || ""}
                                                        onChange={(e) => handleCostoChange(id, e.target.value)}
                                                        disabled={item.nc_siigo === 'Si'}
                                                    />
                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-success btn-sm"
                                                        onClick={() => actualizarCosto(id)}
                                                        title="Guardar Costo"
                                                        disabled={item.nc_siigo === 'Si'}
                                                    >
                                                        Guardar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="13" className="text-center py-4">
                                                No hay datos para mostrar. Ajusta los filtros y presiona Buscar.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {data && data.length > 0 && (
                            <div className="row mt-3">
                                <div className="col-md-12 text-end">
                                    <div className="card d-inline-block">
                                        <div className="card-body p-3">
                                            <h6 className="mb-0">
                                                Total Costo Conductor (Filtro Actual): <span className="fs-5 ms-2 text-primary">
                                                    {calcularTotalCostoConductor().toLocaleString('es-CO', {
                                                        style: 'currency',
                                                        currency: 'COP'
                                                    })}
                                                </span>
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Notas;